module.exports = __webpack_public_path__ + "img/symbols.93fb7529.svg";